import React from 'react';
import { AdsClickIcon, LinkIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import SectionHeaderAndSubtitle from '../SectionHeaderAndSubtitle/SectionHeaderAndSubtitle';
import { ButtonClickSubtitle } from './ButtonClickSubtitle';
import styles from './conversionTypeHeader.module.scss';

export const ConversionTypeHeader = ({ event }) => {
    const isButtonClicks = event.type === CONVERSION_TYPE.EVENT_BASED;
    const urlEvent = event.urlEvent || event.condition?.value || '';
    const category = event.category?.value || event.category || '';

    return (
        <SectionHeaderAndSubtitle
            headerIcon={isButtonClicks ? <AdsClickIcon /> : <LinkIcon />}
            iconClassName={styles['icon-wrapper']}
            headerText={<FormattedMessage id={`tracking.conversion.category.${category}`} defaultMessage={category} />}
            subtitleText={
                isButtonClicks ? (
                    <ButtonClickSubtitle event={event} />
                ) : (
                    <FormattedMessage
                        id="codeless.conversion.url.event"
                        defaultMessage="URL visits -`{urlEvent}`"
                        values={{ urlEvent }}
                    />
                )
            }
        />
    );
};
